module.exports = __webpack_public_path__ + "img/DE00560.2ab3c327.png";